import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useContext } from "react";
import Context from "../context/Context";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useContext(Context);
  const token = Cookies.get("adminToken");

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
    </div>;
  }

  if (!token || !user) {
    return <Navigate to="/login" />;
  }

  const role = user?.role;

  if (allowedRoles && !allowedRoles.includes(role)) {
    if (user?.role === 'superuser') return <Navigate to="/admin/dashboard" />;

  }

  return children;
};

export default PrivateRoute;

